import { useState, useEffect, useContext, useRef } from "react";
import Table from "../../components/Table/Table"
import { Spinner, Tab, Tabs } from "react-bootstrap";
import useApi from "../../helpers/api";
import Navigation from "../../components/Navigation/Navigation";
import SecondaryNavigation from "../../components/SecondaryNavigation/SecondaryNavigation";
import { context, } from '../../context/authContext';

export default function MyAgGridTable() {
    const [compras, setCompras] = useState([]);
    const [entradas, setEntradas] = useState([]);
    const [zonas, setZonas] = useState([]);
    const [productos, setProductos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [key, setKey] = useState("compras");
    const { token } = useContext(context);
    const api = useApi();
    const gridRef = useRef();

    useEffect(() => {
        setLoading(true);
        fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const fetchData = async () => {
        try {
            const compras = await api.getComprasInforme(token);
            const entradas = await api.getEntradasInforme(token);
            const zona = await api.getZonaInforme(token);
            const producto = await api.getProductoInforme(token);

            setCompras(compras.reverse());
            setEntradas(entradas.reverse());
            setZonas(zona);
            setProductos(producto);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
        setLoading(false);
    };

    // Column definitions
    const comprasColumns = [
        { headerName: "Id", field: "id", sortable: true, filter: true },
        { headerName: "Id woo", field: "order_id" },
        { headerName: "Cliente", field: "id" },
        { headerName: "Nombre", field: "nombre" },
        { headerName: "Apellido", field: "apellido" },
        { headerName: "Monto", field: "formatMonto" },
        { headerName: "Email", field: "email" },
        { headerName: "DNI", field: "dni" },
        { headerName: "Provincia", field: "provincia" },
        { headerName: "Ciudad", field: "ciudad" },
        { headerName: "Estado", field: "estado" },
        { headerName: "Cupones", field: "cupones" },
        { headerName: "Fecha", field: "fecha" },
    ];

    const entradasColumns = [
        { headerName: "Id", field: "idEntrada", sortable: true, filter: true },
        { headerName: "Id woo", field: "order_id" },
        { headerName: "Cliente", field: "idCliente" },
        { headerName: "Compra", field: "idCompra" },
        { headerName: "Producto", field: "producto" },
        { headerName: "Nombre", field: "nombre" },
        { headerName: "Apellido", field: "apellido" },
        { headerName: "Email", field: "email" },
        { headerName: "DNI", field: "dni" },
        { headerName: "Zona", field: "zona" },
        { headerName: "Fila", field: "fila" },
        { headerName: "Asiento", field: "columna" },
        { headerName: "Especial", field: "especial" },
        { headerName: "Provincia", field: "provincia" },
        { headerName: "Ciudad", field: "ciudad" },
        { headerName: "Estado", field: "estado" },
        { headerName: "Fecha", field: "fecha" },
    ];

    const zonaColumns = [
        { headerName: "Nombre", field: "nombre", sortable: true },
        { headerName: "Zona", field: "zona", sortable: true },
        { headerName: "Cantidad", field: "cantidad" },
    ];

    const productoColumns = [
        { headerName: "Producto", field: "producto", sortable: true },
        { headerName: "Cantidad", field: "cantidad" },
    ];

    return (
        <>
            <Navigation />
            <SecondaryNavigation title="Informes" />
            <div class="px-4">
                <div className="w-100 d-flex justify-content-end mt-3">
                    <div>
                        <button
                            className="btn btn-primary mb-2 me-2"
                            onClick={() => gridRef.current.api.exportDataAsCsv()}
                        >
                            Descargar CSV
                        </button>
                    </div>
                </div>
                <Tabs id="controlled-tab-example" activeKey={key} onSelect={(k) => setKey(k)} className="mb-3">
                    <Tab eventKey="compras" title="Compras">
                        {loading ? <Spinner animation="border" /> : <Table columns= {comprasColumns} data={compras} gridRef={key === "compras" ? gridRef : null}/>}
                    </Tab>
                    <Tab eventKey="entradas" title="Entradas">
                        {loading ? <Spinner animation="border" /> : <Table columns= {entradasColumns} data={entradas} gridRef={key === "entradas" ? gridRef : null}/>}
                    </Tab>
                    <Tab eventKey="zona" title="Zona">
                        {loading ? <Spinner animation="border" /> : <Table columns= {zonaColumns} data={zonas} gridRef={key === "zona" ? gridRef : null}/>}
                    </Tab>
                    <Tab eventKey="producto" title="Producto">
                        {loading ? <Spinner animation="border" /> : <Table columns= {productoColumns} data={productos} gridRef={key === "producto" ? gridRef : null}/>}
                    </Tab>
                </Tabs>
            </div>
        </>
    );
}
